import Vue from 'vue';
import Router from 'vue-router';
import api from "../api/index";
import store from '../store/index';
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

// 同样处理replace方法
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}


import home from '../pages/home/home';//首页
import newsCenter from '../pages/news/newsCenter';//新闻中心
import news from '../pages/news/index';//新闻列表
import newsList from '../pages/news/newsList';//新闻列表
import newsDetail from '../pages/news/newsDetail';//新闻列表
import partyCenter from '../pages/partyBuilding/partyCenter';//党的建设
import partyBuilding from '../pages/partyBuilding/index';//党的建设
import partyList from '../pages/partyBuilding/partyList';//党的建设-文章列表
import partyDetail from '../pages/partyBuilding/partyDetail';//党的建设详情页 partyDetail
import joinUs from '../pages/joinUs/index';//交控纳贤
import jobBoard from '../pages/joinUs/jobBoard';//招聘公告
import submitResume from '../pages/joinUs/submitResume';//简历投递
import contactUs from '../pages/joinUs/contactUs';//联系我们
import jobDetail from '../pages/joinUs/jobDetail';//招聘详情
import infoDisclosure from '../pages/infoDisclosure/index';//信息公开
import infoList from '../pages/infoDisclosure/infoList';//信息公开文章列表
import infoDetail from '../pages/infoDisclosure/infoDetail';//信息公开文章详情
import aboutUs from '../pages/aboutUs/aboutUs';//关于交控
import search from '../pages/search/search';//搜索
import business from '../pages/business/business';//业务领域

Vue.use(Router);

const router = new Router({
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition!=null) {
           return savedPosition;
        } else {
           return { x: 0, y: 0 };
        }
    },
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: home,
            meta: {
                show: true
            }
        },
        {
            path: '/newsCenter',
            name: 'newsCenter',
            component: newsCenter,
            meta: {
                show: true
            }
        },
        {
            path: '/news',
            name: 'news',
            component: news,
            redirect: '/news/newsList?sort=1',
            children: [
                { path: 'newsList', component: newsList },
                { path: 'newsDetail', component: newsDetail },
            ],
            meta: {
                show: true
            }
        },
        {
            path: '/newsDetail',
            name: 'newsDetail',
            component: newsDetail,
            meta: {
                show: true
            }
        },
        {
            path: '/aboutUs',
            name: 'aboutUs',
            component: aboutUs,
            meta: {
                show: true
            }
        },
        // {
        //     path: '/partyCenter',
        //     name: 'partyCenter',
        //     component: partyCenter,
        //     meta: {
        //         show: true
        //     }
        // },
        {
            path: '/partyBuilding',
            name: 'partyBuilding',
            component: partyBuilding,
            redirect: '/partyBuilding/partyCenter',
            children: [
                { path: 'partyCenter', component: partyCenter },
                { path: 'partyList', component: partyList },
                { path: 'partyDetail', component: partyDetail },
            ],
            meta: {
                show: true
            }
        },
        {
            path: '/business',
            name: 'business',
            component: business,
            meta: {
                show: true
            }
        },
        {
            path: '/joinUs',
            name: 'joinUs',
            component: joinUs,
            redirect: '/joinUs/jobBoard',
            children: [
                { path: 'jobBoard', component: jobBoard },
                { path: 'contactUs', component: contactUs },
                { path: 'jobDetail', component: jobDetail },
            ],
            meta: {
                show: true
            }
        },
        {
            path: '/infoDisclosure',
            name: 'infoDisclosure',
            component: infoDisclosure,
            redirect: '/infoDisclosure/infoList?sort=1',
            children: [
                { path: 'infoList', component: infoList },
                { path: 'infoDetail', component: infoDetail },
            ],
            meta: {
                show: true
            }
        },
        {
            path: '/search',
            name: 'search',
            component: search,
            meta: {
                show: true
            }
        },
    ],
});
function detectDevice() {
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
}
// 全局后置钩子
router.afterEach((to, from) => {
    var isPhone = detectDevice();
    var pth = to.path;
    var hdlist = store.state.headList;
    if(hdlist.length){
        if(pth=='/partyBuilding/partyDetail'){
            store.commit('HEAD_NAV', 4);
        }else if(pth=='/news/newsDetail'){
            store.commit('HEAD_NAV', 3);
        }else{
            for(let i=0;i<hdlist.length;i++){
                if(pth==hdlist[i].name.split('?')[0]){
                    store.commit('HEAD_NAV', i);
                }
                if(pth=='/news/newsList'&&hdlist[i].name.split('?')[0]=='/newsCenter'){
                    store.commit('HEAD_NAV', i);
                }
            }
        }
    }else{
        api.cate().then(res => {
            hdlist = res.data;
            for(let i=0;i<hdlist.length;i++){
                if(pth==hdlist[i].name.split('?')[0]){
                    store.commit('HEAD_NAV', i);
                }
            }
        })
    }
})
export default router